@if (item.art.toString() === "PFANDRECHT") {
  <div>
    <cap-kompakt-grundpfandrecht-beschreibung [recht]="item"></cap-kompakt-grundpfandrecht-beschreibung>
  </div>
} @else {
  <cap-kompakt-standardrecht-beschreibung [item]="item"></cap-kompakt-standardrecht-beschreibung>
}
